module.exports = __webpack_public_path__ + "img/icon_fav.845d92c4.png";